export default __webpack_public_path__ + "static/media/world-land-trust.58497c01.jpg";